import { t } from "./i18n";

// Compassionate off-ramp for non-qualifiers. No submission happens here.
export function renderOfframp(container: HTMLElement, onRestart: () => void): void {
  while (container.firstChild) container.removeChild(container.firstChild);

  const wrapper = document.createElement("div");
  wrapper.className = "offramp";

  const heading = document.createElement("h2");
  heading.textContent = t("ui.offramp.title");
  wrapper.appendChild(heading);

  const message = document.createElement("p");
  message.className = "help-text";
  message.textContent = t("ui.offramp.message");
  wrapper.appendChild(message);

  const restartBtn = document.createElement("button");
  restartBtn.type = "button";
  restartBtn.className = "btn-secondary";
  restartBtn.textContent = t("ui.offramp.restart");
  restartBtn.addEventListener("click", onRestart);
  wrapper.appendChild(restartBtn);

  container.appendChild(wrapper);
}
